import { render, staticRenderFns } from "./Betflixnew.vue?vue&type=template&id=dbbb3b60&scoped=true"
import script from "./Betflixnew.vue?vue&type=script&lang=js"
export * from "./Betflixnew.vue?vue&type=script&lang=js"
import style0 from "./Betflixnew.vue?vue&type=style&index=0&id=dbbb3b60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbb3b60",
  null
  
)

export default component.exports